import React, { type ReactNode } from 'react';
import { type As } from '@mentimeter/ragnar-dsc';
import type { LayoutAccessibilityT } from '@mentimeter/ragnar-styled';

interface ScreenReaderOnlyT extends Omit<LayoutAccessibilityT, 'hidden'> {
  children: ReactNode;
  id?: string;
  as?: As;
}

export const ScreenReaderOnly = ({
  children,
  id,
  as,
  ...rest
}: ScreenReaderOnlyT) => {
  const Element = as || 'span';
  return (
    <Element className="sr-only" id={id} {...rest}>
      {children}
    </Element>
  );
};
